export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M16 7.995L-5.96046e-08 7.99499' stroke='currentColor' strokeWidth='2' />
    <path d='M8.00488 16L8.00488 -5.96046e-08' stroke='currentColor' strokeWidth='2' />
  </svg>
)
